import React, { useState } from 'react';
import { Button } from '../../../components/core/Button/Button';
import { Icon } from '../../../components/core/Icon/Icon';
import {
  IconList,
  Toast,
  createToast,
  dismissToast,
} from '../../../components/core';

type MoveToCategoryProps = {
  category: 'screen' | 'select';
  uniqueIndex: number;
  onMoveToCategory: () => Promise<void>;
};

const MoveToCategory = ({
  category,
  uniqueIndex,
  onMoveToCategory,
}: MoveToCategoryProps) => {
  const [isCollapsing, setIsCollapsing] = useState(false);
  const title = category === 'screen' ? 'screening' : 'full text';
  const pendoKey =
    category === 'screen'
      ? 'move-to-screening-button'
      : 'move-to-full-text-button';

  const handleClick = async () => {
    dismissToast();
    try {
      setIsCollapsing(true);
      await onMoveToCategory();

      createToast(
        <Toast type="success" role="alert">
          {`Study #${uniqueIndex} has been moved to ${title}`}
        </Toast>
      );
    } catch (error: Error | any) {
      setIsCollapsing(false);
      createToast(
        <Toast type="danger" role="alert">
          {`Failed to move study #${uniqueIndex} to ${title}. ${error.message}`}
        </Toast>
      );
    }
  };

  return (
    <Button
      variant="ghost"
      type="brand"
      size="sm"
      isLoading={isCollapsing}
      onClick={handleClick}
      data-pendo-key={pendoKey}
    >
      <Icon icon={IconList.light.faArrowLeftRotate} />
      Move to {title}
    </Button>
  );
};

export default MoveToCategory;
